<template>
  <div class="divNavBar" :class="{ scrollNaver: flag }">
    <div class="divRightMenu">
      <div class="divLogo">
        <img v-if="flag" src="./../../assets/logo_v3.png" width="200 b px" @click="jumpToIndex" />
        <img v-else src="./../../assets/logo_v4.png" width="200px" @click="jumpToIndex" />
      </div>
      <div class="divContent">
        <ul :class="{ divUl: flag }">
          <div class="tagCont">
              <li  @click="routerHandle('/')"><i class="icon iconfont icona-btn_home2x"></i> 返回首页</li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flag: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandle);
  },
  methods: {
    routerHandle(url){
      // this.$router.push(url)
      window.open(url, "_blank");
      this.$store.commit("updateToggleImg", false);
    },
    jumpToIndex() {
      sessionStorage.setItem("subjectID", "1");
      window.open("/home", "_blank");
      // this.$router.push("/home");
      this.$trackEvent("顶部研究院图标", "点击图标");
      this.$store.commit("updateToggleImg", false);
    },
    scrollHandle(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 0){
          this.flag = true
        } else {
          this.flag = false 
        }
    },
  },
};
</script>
<style lang="scss" scoped>
.divNavBar {
  height: 63px;
  line-height: 63px;
  width: 100%;
  min-width: 1180px;
  transition: all 100ms;
  position: fixed;
  z-index: 999;
  .divRightMenu {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: calc(100% - 90px);
    .divContent {
      .tagCont{
         position: relative;
         display: flex;
         padding-right: 15px;
        li{
          font-size: 14px;
          i{
            position: relative;
            top: 1px;
            font-size: 18px;
          }
          color: #fff;
          // &:hover{
          //   color: #1286FF;
          // }
        }
      }
      ul {
        display: flex;
        li {
          position: relative;
          margin-left: 30px;
          cursor: pointer;
          // height: 20px;
          font-size: 14px;
          // font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #19232b;
          // line-height: 20px;
          white-space: nowrap;
          min-width: 30px;
          .sousuo {
            width: 15px;
            height: 15px;
            position: absolute;
            left: 8px;
            top: 5px;
            img {
              width: 15px;
              height: 15px;
            }
          }
          .divClose {
            width: 15px;
            position: absolute;
            top: 5px;
            right: 0px;
            img {
              width: 15px;
            }
          }
          &:first-child {
            margin-left: 0;
          }
          &divLeftMenu {
            margin-left: 20px;
          }
        }
        // li:hover {
        //   color: #1286FF;
        // }
        .liLast {
          margin-right: 0px;
        }
      }
      .divUl {
        width: auto;
      }
    }
  }
  .divLogo {
    img {
      vertical-align: middle;
      cursor: pointer;
    }
  }
  // .divLeftMenu {
  //   position: absolute;
  //   top: 20px;
  //   left: 80px;
  // }
  .labelTop{
    display: flex;
    justify-content: center;
    div{
      cursor: pointer;
      padding: 0 20px;
      a{font-size: 14px;}
      // font-weight: 600;
    }
    .labact{
      position: relative;
      color: #1286ff;
      &::before{
        content: "";
        position: absolute;
        width: 15px;
        height: 15px;
        border-top:solid 1px #ccc;
        border-right:solid 1px #ccc;
        transform: rotateZ(-45deg) translateX(-50%);
        left: 50%;
        bottom: -33px;
        background: #fff;
      }
    }
     .act{
      
      position: relative;
      a,a:hover{
        color: #1286FF;
      }
      &::before{
        content: '';
        position: absolute;
        width: 30px;
        height: 3px;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        background: #1286FF;
      }
    }
  }
}
.scrollNaver{
  background: rgba(255,255,255,0.5);
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.07); 
  backdrop-filter: blur(36px);
  .tagCont{
         position: relative;
         display: flex;
         padding-right: 15px;
        li{
          font-size: 14px;
          i{
            position: relative;
            top: 1px;
            font-size: 18px;
          }
          color: #000 !important;
          &:hover{
            color: #1286FF;
          }
        }
      }
}
</style>
